var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NoteList',{attrs:{"list":_vm.noteList,"is-loading":_vm.isLoading,"title":_vm.$t('text.haveDeadline'),"is-officer":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }